<div class="devices-slots-included-in-plan-box">
    <app-resource-information title="{{'stats-and-resources.transfer' | translate}}"
        description="{{'stats-and-resources.transfer-in-your-plan' | translate}}
                              ({{'stats-and-resources.used' | translate}}/{{'stats-and-resources.total' | translate}})." [chartData]="chartData()"
        [doughnutDescription]="transferResources.currentTransfer + '/' + transferResources.totalTransfer"
        [doughnutHeight]="110" [doughnutWidth]="110">
    </app-resource-information>
</div>
<app-upload-file-to-server (fileUploaded)='onFileUploaded($event)' [methodName]="typesUploading['uploadFileToAWS']"
    [extensions]="allowedFileExtensions"
    [disabled]="transferResources.totalTransfer - transferResources.currentTransfer <= 0">
</app-upload-file-to-server>